import React from "react";
import "./OptionCard.scss"
import tick from "../../assets/tick.svg"
const OptionCard = ({ header, subheader, icon, optionColor = "blue", options }) => {
    return (
        <div className="OptionCard">
            <div className="OptionCard-header-cont">
                <div className={optionColor === "green" ? "OptionCard-header-ic-cont-green" : "OptionCard-header-ic-cont-blue"}>
                    <img alt="" className="OptionCard-icon" src={icon} />
                </div>
                <div className="OptionCard-header-cont-right">
                    <div className="OptionCard-header">
                        {header}
                    </div>
                    <div className="OptionCard-subheader">
                        {subheader}
                    </div>
                </div>
            </div>
            <div className="OptionCard-options-list">
                {options.map((option, key) => {
                    return (
                        <div className="OptionCard-options-list-item" key={key}>

                            <img className="OptionCard-options-list-item-tick" alt="" src={tick} />
                            {option}</div>
                    )
                })}
            </div>
        </div>
    )
}
export default OptionCard